module.exports = __webpack_public_path__ + "assets/img/923021.67ef3efb.jpg";